import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/auth'
// import 'firebase/admin'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    // This is xiyi06 settings
    apiKey: "AIzaSyDMje18Sxu_NLxcEi0R3RXk89yXlgkK-ds",
    authDomain: "xiyi06-b6a25.firebaseapp.com",
    projectId: "xiyi06-b6a25",
    storageBucket: "xiyi06-b6a25.appspot.com",
    messagingSenderId: "215203607828",
    appId: "1:215203607828:web:9b741fcb86ad4b4ed5be01",
    measurementId: "G-LMTQNESGEH"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Make db and auth references
export const db = firebase.firestore()
export const auth = firebase.auth()
//export const admin = firebase.admin()
export const fstore = firebase.firestore 
export const firebaseFunctions = firebase.functions()